// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__7VZ1-","badgeNot":"Badge_badgeNot__LJm4l","icon":"Badge_icon__OO75W","text":"Badge_text__9gBsA"};